import React from 'react';
import { useSelector } from 'react-redux';
import QuizManager from '../../../classes/QuizManager';
import { LayoutOrientations, QuizType } from '../../../globals';
import QuizSettingsDialog from '../../checklist/QuizSettingsDialog';
import { IconFillStyles, WarningIcon } from '../../Iconset';
import Button from '../../layout/Button';
import ModalManager from '../../layout/ModalManager';
import Panel from '../../layout/Panel';
import Separator from '../../layout/Separator';
import Spacer from '../../layout/Spacer';
import UINextStep  from '../subcomponents/UINextStep';
import UIVoice  from '../subcomponents/UIVoice';
import UIContinueButton  from '../subcomponents/UIContinueButton';
import UIRetryButton  from '../subcomponents/UIRetryButton';
import subComponentTypes from '../subcomponents/types';
import UIScoreNumber from '../subcomponents/UIScoreNumber';

export default function TQuizResults(props)
{
	if(props.getProperties)
	{
		return {
			[subComponentTypes.NEXT_STEP]:{ ...UINextStep({ ...props }) },
			[subComponentTypes.SCORE_NUMBER]:{ ...UIScoreNumber({ ...props }) },
			[subComponentTypes.CONTINUE_BUTTON]:{ ...UIContinueButton({ ...props }) },
			[subComponentTypes.RETRY_BUTTON]:{ ...UIRetryButton({ ...props }) },
			[subComponentTypes.VOICE]:{ ...UIVoice({ ...props }) }
		};
	}
	else
	{
		const quizSettings = useSelector(store => store.checklistModule.quizSettings);
		const isGradedQuiz = quizSettings.type === QuizType.GRADED;
		const anyGradedQuestions = QuizManager.areThereAnyGradedQuestions();

		return (
			<>
				{
					anyGradedQuestions ? null :
						<div className={"solid padded extra"}> 
							<Panel className={"centerContentVertically"} orientation={LayoutOrientations.Horizontal}>
								<WarningIcon fillStyle={IconFillStyles.red} />
								<Spacer size={{ x: "6px" }} />
								Add a graded quiz question to a step to enable quiz results
							</Panel>
						</div>
				}
				{
					isGradedQuiz ? null :
						<div className={"solid padded extra"}> 
							<Panel className={"centerContentVertically"} orientation={LayoutOrientations.Horizontal}>
								<WarningIcon fillStyle={IconFillStyles.red} />
								<Spacer size={{ x: "6px" }} />
								Set the project to be a graded quiz in the Quiz Settings to enable quiz results
							</Panel>							
						</div>
				}				
				{
					!isGradedQuiz || !anyGradedQuestions ? <Separator orientation={LayoutOrientations.Horizontal} /> : null
				}
				<div className={"solid padded extra"}>
					<Spacer size={{ y: "4px" }} />
					<Button data-name={"open-quiz-settings"}
						label={"Quiz Settings"}
						onClick={() => { ModalManager.addModal({ showBackdrop: true, content: <QuizSettingsDialog /> })}}
					/>
				</div>
				<UIScoreNumber {...props} />
				<UIContinueButton {...{...props, disabledProperties: ['visible']}} />
				<UIRetryButton {...props} />
			</>
		);
	}
}